export const USER_TEAM_FONTS_REQUEST = "API/ENTITIES/USER_TEAM_FONTS_REQUEST";
export const USER_TEAM_FONTS_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_FONTS_REQUEST_FAILURE";
export const USER_TEAM_FONTS_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_FONTS_REQUEST_SUCCESS";

export const USER_TEAM_FONT_REMOVE_REQUEST =
  "API/ENTITIES/USER_TEAM_FONT_REMOVE_REQUEST";
export const USER_TEAM_FONT_REMOVE_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_FONT_REMOVE_REQUEST_SUCCESS";
export const USER_TEAM_FONT_REMOVE_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_FONT_REMOVE_REQUEST_FAILURE";

export const USER_UPLOAD_FONT_REQUEST = "API/ENTITIES/UPLOAD_FONT_REQUEST";
export const USER_UPLOAD_FONT_REQUEST_SUCCESS =
  "API/ENTITIES/UPLOAD_FONT_REQUEST_SUCCESS";
export const USER_UPLOAD_FONT_REQUEST_FAILURE =
  "API/ENTITIES/UPLOAD_FONT_REQUEST_FAILURE";

export const USER_TEAM_FONTS_CREATE_DELETE_REQUEST =
  "API/ENTITIES/USER_TEAM_FONTS_CREATE_DELETE_REQUEST";
export const USER_TEAM_FONTS_CREATE_DELETE_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_FONTS_CREATE_DELETE_REQUEST_FAILURE";
export const USER_TEAM_FONTS_CREATE_DELETE_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_FONTS_CREATE_DELETE_REQUEST_SUCCESS";

export const USER_TEAM_FONTS_DELETE_REQUEST =
  "API/ENTITIES/USER_TEAM_FONTS_DELETE_REQUEST";
export const USER_TEAM_FONTS_DELETE_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_FONTS_DELETE_REQUEST_FAILURE";
export const USER_TEAM_FONTS_DELETE_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_FONTS_DELETE_REQUEST_SUCCESS";

export const USER_FONTS_IS_PROCESSING = "API/ENTITIES/USER_FONTS_PROCESSING";
